import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmCheckbox {
    key: string;
    label: string;
    checked: boolean;
}

@Component({
    selector: 'app-confirm-message',
    templateUrl: './confirm-message.component.html',
    styleUrls: ['./confirm-message.component.scss']
})
export class ConfirmMessageComponent {
    checkboxes: ConfirmCheckbox[] = [];

    constructor(
        public dialogRef: MatDialogRef<ConfirmMessageComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string;
            message: string;
            confirmText: string;
            cancelText?: string;
            isDelete?: boolean;
            showCancel?: boolean;
            checkboxes?: ConfirmCheckbox[];
            maxWidth?: string;
        }
    ) {
        if (data.checkboxes) {
            this.checkboxes = data.checkboxes.map(cb => ({ ...cb }));
        }
    }

    onConfirm(): void {
        if (this.checkboxes.length > 0) {
            const result: Record<string, boolean> = { confirmed: true };
            for (const cb of this.checkboxes) {
                result[cb.key] = cb.checked;
            }
            this.dialogRef.close(result);
        } else {
            this.dialogRef.close(true);
        }
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
